import React, { useState, useEffect, useRef } from "react";
import "./styles/Calendar.css";
import axios from "axios";

// Function to convert UTC to local date string
const convertUTCToLocal = (utcString) => {
    const localDate = new Date(utcString);
    return localDate.toISOString(); // Keeps full local timestamp
};

const Calendar = ({ selectedTech, setSelectedTech, selected, setSelected, scrollRef, answers, calendarRef, borderHighlight }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [filteredSchedule, setFilteredSchedule] = useState([]);
    const [activeTimeSlot, setActiveTimeSlot] = useState(() => selected[5] || null);
    const [activeDate, setActiveDate] = useState();
    const [fullHoursData, setFullHoursData] = useState([]);


    // Convert closed dates to local time before rendering
    const [closedDates, setClosedDates] = useState(() =>
        [
            // "2025-02-26T00:00:00Z",
            // "2025-02-27T00:00:00Z",
            // "2025-03-01T00:00:00Z",
            // "2025-03-09T00:00:00Z"
        ].map(date => convertUTCToLocal(date))
    );

    const [schedule, setSchedule] = useState([]);
    const [clientLimits, setClientLimits] = useState({ minHours: 24, maxWeeks: 2 });
    const [fullyBookedDates, setFullyBookedDates] = useState([]);

    useEffect(() => {
        const fetchClientLimits = async () => {
            try {
                const response = await axios.get("https://bunny-klawz.uc.r.appspot.com/settings/client-limits");
                setClientLimits(response.data);
            } catch (error) {
                console.error("❌ Failed to fetch client limits:", error);
            }
        };

        fetchClientLimits();
    }, []);


    let sortedSchedule = schedule.sort((a, b) => new Date(a.date) - new Date(b.date));

    // console.log(sortedSchedule);

    const scrollToTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const scrollToSlots = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    };

    const [repeatingHours, setRepeatingHours] = useState({ enabled: false });


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [hoursRes, appointmentsRes, repeatingRes] = await Promise.all([
                    axios.get("https://bunny-klawz.uc.r.appspot.com/working-hours"),
                    axios.get("https://bunny-klawz.uc.r.appspot.com/appointments"),
                    axios.get("https://bunny-klawz.uc.r.appspot.com/settings/repeating-hours")
                ]);

                let hoursData = hoursRes.data;
                const appointmentsData = appointmentsRes.data.filter(
                    appt => appt.status !== "rejected" && appt.status !== "cancelled"
                );
                const repeatingData = repeatingRes.data;
                setRepeatingHours(repeatingData);

                let allHours = [];

                if (repeatingData.enabled) {
                    // generate repeating hours like before...
                } else {
                    allHours = [...hoursData]; // use DB hours only if not repeating
                }

                if (repeatingData.enabled) {
                    const startTime = repeatingData.start.split(":");
                    const endTime = repeatingData.end.split(":");
                    const maxDate = new Date(repeatingData.maxDate);

                    const now = new Date();
                    let currentDate = new Date(now.setHours(0, 0, 0, 0));

                    while (currentDate <= maxDate) {
                        const techs = ["Kayla", "Leah", "Kelly"];
                        for (let tech of techs) {
                            if (selectedTech === tech || selectedTech === "No preference" || selectedTech === "") {
                                const start = new Date(currentDate);
                                start.setHours(parseInt(startTime[0]), parseInt(startTime[1]), 0, 0);

                                const end = new Date(currentDate);
                                end.setHours(parseInt(endTime[0]), parseInt(endTime[1]), 0, 0);

                                allHours.push({
                                    nailtech: tech,
                                    start: start.toISOString(),
                                    end: end.toISOString()
                                });
                            }
                        }
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                }

                setFullHoursData(allHours);

                const bookedSlots = appointmentsData.map(app => app.appointmentDetails?.[5]);
                const generatedSlots = [];

                const scheduleByDateTemp = {};

                for (const hour of allHours) {
                    const tech = hour.nailtech;
                    const start = new Date(hour.start);
                    const end = new Date(hour.end);
                    const dateStr = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;

                    const isValidTech =
                        tech === selectedTech ||
                        selectedTech === "No preference" ||
                        selectedTech === "";

                    if (!isValidTech) continue;

                    const durationEstimate = answers.reduce((t, x) => t + x.time, 0);
                    const now = new Date();
                    const nowPlusMinHours = new Date(now.getTime() + clientLimits.minHours * 60 * 60 * 1000);
                    const nowPlusMaxWeeks = new Date(now.getTime() + clientLimits.maxWeeks * 7 * 24 * 60 * 60 * 1000);

                    let slotStart = new Date(start);
                    if (slotStart < nowPlusMinHours) slotStart = new Date(nowPlusMinHours);
                    if (slotStart > nowPlusMaxWeeks) continue;

                    let hasAnySlot = false;

                    while (slotStart.getTime() + durationEstimate * 60000 <= end.getTime()) {
                        const slotEnd = new Date(slotStart.getTime() + durationEstimate * 60000);

                        const conflict = bookedSlots.some(booked => {
                            if (!booked?.artist || !booked?.date || !booked?.duration) return false;
                            const bookedStart = new Date(booked.date);
                            const bookedEnd = new Date(bookedStart.getTime() + booked.duration * 60000);
                            return booked.artist === tech && bookedStart < slotEnd && bookedEnd > slotStart;
                        });

                        if (!conflict && slotStart > nowPlusMinHours && slotStart <= nowPlusMaxWeeks) {
                            generatedSlots.push({
                                artist: tech,
                                date: slotStart.toISOString(),
                                duration: durationEstimate,
                                isBooked: false
                            });
                            hasAnySlot = true;
                        }

                        slotStart = new Date(slotStart.getTime() + 60 * 60000);
                    }

                    if (!hasAnySlot) {
                        scheduleByDateTemp[dateStr] = { total: 0, booked: 0, noRoom: true };
                    }
                }

                generatedSlots.sort((a, b) => new Date(a.date) - new Date(b.date));

                // Create a map to group slots by timestamp (ignoring artist)
                const groupedByTime = generatedSlots.reduce((acc, slot) => {
                    const timeKey = new Date(slot.date).toISOString();
                    if (!acc[timeKey]) acc[timeKey] = [];
                    acc[timeKey].push(slot);
                    return acc;
                }, {});

                // Flip-flop toggle to alternate between artists
                let toggle = true;
                const deduplicatedSlots = [];

                for (const time in groupedByTime) {
                    const group = groupedByTime[time];

                    if (group.length === 1) {
                        deduplicatedSlots.push(group[0]); // Only one slot, keep it
                    } else {
                        // Multiple artists at same time — alternate who to keep
                        const slotToKeep = toggle ? group[0] : group[1] || group[0];
                        deduplicatedSlots.push(slotToKeep);
                        toggle = !toggle;
                    }
                }

                // Convert generated slots to local time
                const convertedGenerated = deduplicatedSlots.map(entry => ({
                    ...entry,
                    date: convertUTCToLocal(entry.date)
                }));

                // Convert booked appointment slots from appointmentDetails
                const convertedBooked = appointmentsData
                    .map(entry => {
                        const booking = entry?.appointmentDetails?.[5];
                        if (booking && booking.date && booking.duration) {
                            return {
                                ...booking,
                                isBooked: true,
                                date: convertUTCToLocal(booking.date)
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                // console.log([...convertedGenerated, ...convertedBooked]);

                // Combine both and set to schedule
                setSchedule([...convertedGenerated, ...convertedBooked]);

                const allDates = [];
                const now = new Date();
                const futureLimit = new Date(now.getTime() + clientLimits.maxWeeks * 7 * 24 * 60 * 60 * 1000);
                let current = new Date(now.getTime() + clientLimits.minHours * 60 * 60 * 1000);
                current.setHours(0, 0, 0, 0);

                while (current <= futureLimit) {
                    const localDateStr = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}-${String(current.getDate()).padStart(2, '0')}`;
                    allDates.push(localDateStr);
                    current.setDate(current.getDate() + 1);
                }

                const formatLocalDate = (d) =>
                    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

                let workingHourDates = new Set(
                    fullHoursData
                        .filter(h => h.nailtech === selectedTech ||
                            selectedTech === "No preference" || selectedTech === "")
                        .map(h => formatLocalDate(new Date(h.start)))
                );

                let slotDates = new Set(
                    generatedSlots
                        .filter(slot => slot.artist === selectedTech ||
                            selectedTech === "No preference" || selectedTech === "")
                        .map(slot => formatLocalDate(new Date(slot.date)))
                );

                // workingHourDates = new Set(
                //     fullHoursData
                //         .filter(h => h.nailtech === selectedTech ||
                //             selectedTech === "No preference" || selectedTech === "")
                //         .map(h => new Date(h.start).toISOString().split("T")[0])
                // );

                // slotDates = new Set(
                //     generatedSlots
                //         .filter(slot => slot.artist === selectedTech ||
                //             selectedTech === "No preference" || selectedTech === "")
                //         .map(slot => new Date(slot.date).toISOString().split("T")[0])
                // );

                // console.log(slotDates);

                // const availableDates = new Set(
                //     generatedSlots
                //         .filter(slot => !slot.isBooked &&
                //             (slot.artist === selectedTech ||
                //                 selectedTech === "No preference" || selectedTech === ""))
                //         .map(slot => new Date(slot.date).toISOString().split("T")[0])
                // );

                const fullyBooked = allDates.filter(date => workingHourDates.has(date) && !slotDates.has(date));
                setFullyBookedDates(fullyBooked);

                // console.log(fullyBooked);


                // console.log("filtering:" + allDates.filter(date => workingHourDates.has(date) && !slotDates.has(date)))
                // console.log("fully booked:" + fullyBooked);

                const noWorkingOrSlot = allDates.filter(date => !workingHourDates.has(date) && !slotDates.has(date));
                const workingButNoSlots = allDates.filter(date => workingHourDates.has(date) && !slotDates.has(date));

                // console.log(noWorkingOrSlot, workingButNoSlots);

                const closedFinal = Array.from(new Set([...noWorkingOrSlot, ...workingButNoSlots]));
                setClosedDates(closedFinal.map(d => {
                    const [year, month, day] = d.split("-").map(Number);
                    return new Date(Date.UTC(year, month - 1, day)).toISOString();
                }));
            } catch (error) {
                console.error("❌ Error loading data:", error);
            }
        };

        fetchData();
    }, [selectedTech]);


    useEffect(() => {
        if (calendarRef.current && selectedTech) {
            setActiveDate(null);
            calendarRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [selectedTech])

    useEffect(() => {
        if (selected[5]) {
            setActiveTimeSlot(selected[5]);
        }

        let updatedSchedule = sortedSchedule;

        // console.log(sortedSchedule);

        if (selectedTech !== "No preference" && selectedTech !== "") {
            updatedSchedule = sortedSchedule.filter(entry => entry.artist === selectedTech);
        }

        // Remove booked entries
        // updatedSchedule = updatedSchedule.filter(entry => !entry.isBooked);

        console.log(updatedSchedule);

        const someClosedDates = closedDates.filter(closedDateStr => {
            const closed = new Date(closedDateStr);
            closedDates.some(entry => entry.date === entry.date)
            return `${closed.getFullYear()}-${String(closed.getMonth() + 1).padStart(2, '0')}-${String(closed.getDate()).padStart(2, '0')}`;
        })
        console.log(someClosedDates);

        // Compare **only** the date part, but keep full time information
        updatedSchedule = updatedSchedule.filter(entry => {
            const entryDateLocal = new Date(entry.date);
            const entryDateStr = `${entryDateLocal.getFullYear()}-${String(entryDateLocal.getMonth() + 1).padStart(2, '0')}-${String(entryDateLocal.getDate()).padStart(2, '0')}`;

            // console.log("updatedsched");
            // console.log(updatedSchedule);

            const closedDateMatches = closedDates.some(closedDateStr => {
                // const closed = new Date(closedDateStr);
                // const closedLocalStr = `${closed.getFullYear()}-${String(closed.getMonth() + 1).padStart(2, '0')}-${String(closed.getDate()).padStart(2, '0')}`;

                const closedLocalStr = closedDateStr.split("T")[0]; // "2025-04-25"

                if (entry.date === "2025-04-18T21:00:00.000Z") {
                    console.log(closedLocalStr, entryDateStr);
                }
                return closedLocalStr === entryDateStr;
            });

            return !closedDateMatches;
        });

        console.log(updatedSchedule);

        setFilteredSchedule(updatedSchedule);
    }, [selectedTech, closedDates]);

    function formatDate(timestamp) {
        const date = new Date(timestamp);

        // Get formatted date components
        const formattedDate = date.toLocaleString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        });

        // Extract timezone abbreviation
        const timeZone = date.toLocaleTimeString("en-US", { timeZoneName: "short" }).split(" ").pop();

        return `${formattedDate} (${timeZone})`;
    }


    const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
    const firstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

    const handlePrevMonth = () => {
        setCurrentDate(
            new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
        );
    };

    const handleNextMonth = () => {
        setCurrentDate(
            new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
        );
    };

    const renderDays = () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const totalDays = daysInMonth(year, month);
        const startDay = firstDayOfMonth(year, month);

        let days = [];

        // Build initial scheduleByDate from schedule entries
        const scheduleByDate = schedule.reduce((acc, entry) => {
            const dateObj = new Date(entry.date);
            const dateStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
            if (!acc[dateStr]) acc[dateStr] = { total: 0, booked: 0 };
            acc[dateStr].total += 1;
            if (entry.isBooked) acc[dateStr].booked += 1;
            return acc;
        }, {});

        // Add fully booked markers for dates that had working hours but no generated slots (i.e., couldn't fit duration)
        const consideredDates = new Set(Object.keys(scheduleByDate));
        fullHoursData.forEach(hour => {
            const tech = hour.nailtech;
            const start = new Date(hour.start);
            const end = new Date(hour.end);
            const dateStr = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;

            const isValidTech =
                tech === selectedTech ||
                selectedTech === "No preference" ||
                selectedTech === "";

            if (!isValidTech || consideredDates.has(dateStr)) return;

            const durationEstimate = answers.reduce((t, x) => t + x.time, 0);
            const slotStart = new Date(start);
            const slotEnd = new Date(slotStart.getTime() + durationEstimate * 60000);

            // If there's no room for even one slot
            if (slotEnd > end) {
                scheduleByDate[dateStr] = { total: 0, booked: 0, noRoom: true };
            }
        });

        for (let i = 0; i < startDay; i++) {
            days.push(<div key={`empty-${i}`} className="empty"></div>);
        }

        for (let day = 1; day <= totalDays; day++) {
            const dateObj = new Date(year, month, day);
            const dateStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
            const isClosed = closedDates.some(closedDate => {
                return closedDate.startsWith(dateStr);
            });

            const isToday =
                day === new Date().getDate() &&
                month === new Date().getMonth() &&
                year === new Date().getFullYear();

            const daySchedule = scheduleByDate[dateStr] || { total: 0, booked: 0 };
            const isFullyBooked = fullyBookedDates.includes(dateStr);
            const isAvailable = !isClosed && daySchedule.total > 0 && daySchedule.booked < daySchedule.total;

            let className = "day";
            if (isToday) className += " today";
            if (isClosed) {

                if (isFullyBooked) {
                    className += " fully-booked";
                } else {
                    className += " closed"; // Prioritize closed

                }
            } else if (isAvailable) {
                className += " available";
            }


            days.push(
                <div
                    key={day}
                    className={className + ` ${(activeDate === dateStr) ? "highlight" : ""}`}
                    onClick={() => {
                        if (!isClosed && !isFullyBooked && isAvailable) {
                            if (dateStr === activeDate) {
                                setActiveDate(null)
                            } else {
                                setActiveDate(dateStr);
                                // scrollToSlots();
                            }
                        }
                    }}>
                    <span className="day-text">{day}</span>
                    {isClosed && <span className="closed-x">X</span>}
                    {isFullyBooked && <img className="booked-bunny" src="/images/HotPinkCalendarBunny.png" alt="Booked Bunny" />}
                </div>
            );
        }
        return days;
    };

    const renderTimes = () => {

        // console.log(filteredSchedule.length);

        if (selectedTech !== "No preference" && selectedTech !== "") {

            if (filteredSchedule.length === 0) {
                return <div className="questionZ warning fade">
                    <img src="/images/Warning.png" alt="Warning" />
                    <div className="reselection">
                        <p className="warning-text">{selectedTech} has no availability at this time.</p>
                        {(selectedTech !== "Kayla" && <p className="switch-text">Switch to <button className="switch-button" onClick={() => { setSelectedTech("Kayla") }}>Kayla</button>?</p>)}
                        {(selectedTech !== "Leah" && <p className="switch-text">Switch to <button className="switch-button" onClick={() => { setSelectedTech("Leah") }}>Leah</button>?</p>)}
                        {(selectedTech !== "Kelly" && <p className="switch-text">Switch to <button className="switch-button" onClick={() => { setSelectedTech("Kelly") }}>Kelly</button>?</p>)}
                    </div>
                </div>;
            }
        } else if (selectedTech === "No preference" || selectedTech === "") {

            if (filteredSchedule.length === 0) {
                return <div className="questionZ warning fade">
                    <img src="/images/Warning.png" alt="Warning" />
                    <p className="warning-text">We apologize, there is no availability at this time.</p>
                </div>;
            }
        }

        let removeBooked = filteredSchedule.filter(entry => !entry.isBooked);

        if (activeDate) {
            // console.log(filteredSchedule);
            // Only keep unbooked entries for the selected date
            removeBooked = removeBooked.filter(entry => {
                const localDate = new Date(entry.date);
                const formattedLocalDate = localDate.getFullYear() + "-" +
                    String(localDate.getMonth() + 1).padStart(2, '0') + "-" +
                    String(localDate.getDate()).padStart(2, '0');
                return formattedLocalDate === activeDate;
            });

        }

        const groupedByDate = removeBooked.reduce((acc, entry) => {

            const date = formatDate(entry.date);

            if (!acc[date]) acc[date] = [];
            acc[date].push(entry);
            return acc;
        }, {});

        return <div className={`booking-times ${borderHighlight ? "borderHighlight" : ""}`}>
            {Object.entries(groupedByDate).map(([date, bookings]) => (
                <div key={date} className="times-section">
                    <h3 className="date-header">
                        {date}
                    </h3>
                    <div className="times-list">
                        {bookings.sort((a, b) => new Date(a.date) - new Date(b.date)).map((booking, index) => (
                            <div
                                key={index}
                                className={`time-slot available ${activeTimeSlot?.date === booking.date && activeTimeSlot?.artist === booking.artist ? "active" : ""}`}
                                onClick={() => {
                                    const tempSelectedList = [...selected];
                                    tempSelectedList[5] = booking;
                                    setSelected(tempSelectedList);

                                    setActiveTimeSlot(booking); // set full booking, not just date
                                }}
                            >
                                <span>{/*{booking.artist}: */}{new Date(booking.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    };


    return (<>
        {((selectedTech !== "") && <div key={selectedTech} className="schedule-container fade">
            {(filteredSchedule.length !== 0 && <div className="calendar-container">
                <div className="pink-box" ref={calendarRef}>
                    <div className="header">
                        <div className="calendar-header">
                            <button onClick={handlePrevMonth}>&lt;</button>
                            <h2>
                                {currentDate.toLocaleString("default", {
                                    month: "long",
                                })} {" "}
                                {currentDate.getFullYear()}
                            </h2>
                            <button onClick={handleNextMonth}>&gt;</button>
                        </div>
                        <div className="calendar-grid">
                            <div className="day-header">Sun</div>
                            <div className="day-header">Mon</div>
                            <div className="day-header">Tue</div>
                            <div className="day-header">Wed</div>
                            <div className="day-header">Thu</div>
                            <div className="day-header">Fri</div>
                            <div className="day-header">Sat</div>
                        </div>
                    </div>
                    <div className="grid-container">
                        <div className="calendar-grid">
                            {renderDays()}
                        </div>
                    </div>
                </div>
                <div className="calendar-legend">
                    <span><div className="day available"><div className="day-text"></div></div> Open</span>
                    <span><img src="/images/HotPinkCalendarBunny.png" alt="Booked Bunny" /> Full</span>
                    <span><span className="legend-closed">X</span> Closed</span>
                </div>


            </div>)}
            {renderTimes()}
        </div>)}</>
    );
};

export default Calendar;